<template>

    <!--new total ui start-->
    <div v-if="!isFooter" class="wrapper-obo" >
        <div class="top">
            <span>{{$t('totalpriceInfo.totalAmt')}}</span>
        </div>
        <div class="bottom">
            <div class="currency">
                {{totalPriceObj.Currency}}
            </div>
            <div class="value">
                <!-- {{totalPriceObj.TotalAmount | amountformat}} -->
                  <number
    class="bold transition"
    
    :from="0"
    :format="theFormat"
    :animationPaused="false"
    :to="totalPriceObj.TotalAmount"
    :duration="0.5"
    easing="Power4.easeOut"
   />
            </div>
        </div>
    </div>


            <div v-else class="total-price-wrap">
                <table class="total">
                    <tbody>
                    <tr class="active">
                        <td>
                            <div>{{$t("totalpriceInfo.total")}}</div>
                        </td>
                        <td></td>
                        <td>
                            <div class="currency">{{totalPriceObj.Currency}}</div>
                        </td>
                        <td>
                            <div class="value"> 
                              <number
                          class="bold transition" :from="0" :format="theFormat"
                          :animationPaused="false" :to="totalPriceObj.TotalAmount" :duration="0.5"
  easing="Power4.easeOut"
    />
</div>
                        </td>
                    </tr>
                    </tbody>
                </table>
             
            </div>
            

    <!--new total ui end-->


<!-- <div  :class="!isFooter?'price-details-wrap':''">
                                        <div  :class="!isFooter?'search-modify-wrap':'' ">
                                            <div  class="total-price-wrap"> -->
   <!-- <table > -->
                                                    <!-- <div>{{$t('totalpriceInfo.totalAmt')}}</div>
                                                    <div>{{totalPriceObj.Currency}}</div>
                                                    <div>{{totalPriceObj.TotalAmount}}</div> -->
                                                    <!-- <tbody @click="playAnimation">
                                                    <tr class="active">
                                                        <td>
                                                            <div> {{$t('totalpriceInfo.total')}}</div>
                                                        </td>
                                                        
                                                        <td>
                                                            <div class="currency">{{totalPriceObj.Currency}}</div>
                                                        </td>
                                                        <td> -->
                                                            <!-- <div class="value">{{totalPriceObj.TotalAmount | amountformat}}</div> -->
                                                          <!-- <div class="value">            
                                                        <number
    class="bold transition"
    :class="{scaleBig: scaleClass}"
    ref="totalPaxNum"
    :from="0"
    :format="theFormat"
    :animationPaused="false"
    :to="totalPriceObj.TotalAmount"
    :duration="1"
    easing="Power4.easeOut"
    @complete="completed"/>
</div>
   
                                                          
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                    <transition v-if="!isFooter" name="bounce">
                                                    <tbody v-if="isTotalFare && !isFooter" >
                                                     <tr>
                                                        <td>
                                                            <div class="taxes"> {{$t('totalpriceInfo.tax')}}  </div>
                                                        </td>
                                                        <td></td>
                                                        <td>
                                                            <div class="currency">{{totalPriceObj.Currency}}</div>
                                                        </td>
                                                        <td>
                                                            <div class="value">{{totalPriceObj.TotalTax | amountformat}}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <div class="taxes"> {{$t('totalpriceInfo.baseFare')}}</div>
                                                        </td>
                                                        <td></td>
                                                        <td>
                                                            <div class="currency">{{totalPriceObj.Currency}}</div>
                                                        </td>
                                                        <td>
                                                            <div class="value">{{totalPriceObj.TotalBaseFare | amountformat}}</div> -->
   

                                                                <!-- <number
                                                                    class="bold transition"
                                                                    :class="{scaleBig: scaleClass}"
                                                                    ref="number2"
                                                                    :from="numberFrom"
                                                                    :format="theFormat"
                                                                    animationPaused
                                                                    :to="numberTo"
                                                                    :duration="duration"
                                                                    easing="Power4.easeOut"
                                                                    /> -->
                                                        <!-- </td>
                                                    </tr>
                                                   
                                                    </tbody>
                                                    </transition> -->
                                                    <!-- <transition v-if="!isFooter" name="bounce"> -->
<!--    old total ui with functionality start-->

<!--   <table>-->
<!--                                                    &lt;!&ndash; <div>{{$t('totalpriceInfo.total')}}</div>-->
<!--                                                    <div>{{totalPriceObj.Currency}}</div>-->
<!--                                                    <div>{{totalPriceObj.TotalAmount}}</div> &ndash;&gt;-->
<!--                                                    <tbody @click="playAnimation">-->
<!--                                                    <tr class="active">-->
<!--                                                        <td>-->
<!--                                                            <div> {{$t('totalpriceInfo.total')}}</div>-->
<!--                                                        </td>-->

<!--                                                        <td>-->
<!--                                                            <div class="currency">{{totalPriceObj.Currency}}</div>-->
<!--                                                        </td>-->
<!--                                                        <td>-->
<!--                                                            <div class="value">{{totalPriceObj.TotalAmount | amountformat}}</div>-->




<!--                                                        </td>-->
<!--                                                    </tr>-->
<!--                                                    </tbody>-->
<!--                                                    <transition v-if="!isFooter" name="bounce">-->
<!--                                                    <tbody v-if="isTotalFare && !isFooter" >-->
<!--                                                     <tr>-->
<!--                                                        <td>-->
<!--                                                            <div class="taxes"> {{$t('totalpriceInfo.tax')}}  </div>-->
<!--                                                        </td>-->
<!--                                                        <td></td>-->
<!--                                                        <td>-->
<!--                                                            <div class="currency">{{totalPriceObj.Currency}}</div>-->
<!--                                                        </td>-->
<!--                                                        <td>-->
<!--                                                            <div class="value">{{totalPriceObj.TotalTax | amountformat}}</div>-->
<!--                                                        </td>-->
<!--                                                    </tr>-->
<!--                                                    <tr>-->
<!--                                                        <td>-->
<!--                                                            <div class="taxes"> {{$t('totalpriceInfo.baseFare')}}</div>-->
<!--                                                        </td>-->
<!--                                                        <td></td>-->
<!--                                                        <td>-->
<!--                                                            <div class="currency">{{totalPriceObj.Currency}}</div>-->
<!--                                                        </td>-->
<!--                                                        <td>-->
<!--                                                            <div class="value">{{totalPriceObj.TotalBaseFare | amountformat}}</div>-->

<!--                                                                &lt;!&ndash; <number-->
<!--                                                                    class="bold transition"-->
<!--                                                                    :class="{scaleBig: scaleClass}"-->
<!--                                                                    ref="number2"-->
<!--                                                                    :from="numberFrom"-->
<!--                                                                    :format="theFormat"-->
<!--                                                                    animationPaused-->
<!--                                                                    :to="numberTo"-->
<!--                                                                    :duration="duration"-->
<!--                                                                    easing="Power4.easeOut"-->
<!--                                                                    /> &ndash;&gt;-->
<!--                                                        </td>-->
<!--                                                    </tr>-->

<!--                                                    </tbody>-->
<!--                                                    </transition>-->
<!--                                                    &lt;!&ndash; <transition v-if="!isFooter" name="bounce"> &ndash;&gt;-->
<!--&lt;!&ndash;                                                    <tbody v-if="isTotalFare && !isFooter" >&ndash;&gt;-->
<!--&lt;!&ndash;                                                     <tr>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        <td>&ndash;&gt;-->
<!--&lt;!&ndash;                                                            <div class="taxes"> {{$t('totalpriceInfo.tax')}}  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        </td>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        <td></td>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        <td>&ndash;&gt;-->
<!--&lt;!&ndash;                                                            <div class="currency">{{totalPriceObj.Currency}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        </td>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        <td>&ndash;&gt;-->
<!--&lt;!&ndash;                                                            <div class="value">{{totalPriceObj.TotalTax | amountformat}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        </td>&ndash;&gt;-->
<!--&lt;!&ndash;                                                    </tr>&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <tr>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        <td>&ndash;&gt;-->
<!--&lt;!&ndash;                                                            <div class="taxes"> {{$t('totalpriceInfo.baseFare')}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        </td>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        <td></td>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        <td>&ndash;&gt;-->
<!--&lt;!&ndash;                                                            <div class="currency">{{totalPriceObj.Currency}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        </td>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        <td>&ndash;&gt;-->
<!--&lt;!&ndash;                                                            <div class="value">{{totalPriceObj.TotalBaseFare | amountformat}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                                &lt;!&ndash; <number&ndash;&gt;-->
<!--&lt;!&ndash;                                                                    class="bold transition"&ndash;&gt;-->
<!--&lt;!&ndash;                                                                    :class="{scaleBig: scaleClass}"&ndash;&gt;-->
<!--&lt;!&ndash;                                                                    ref="number2"&ndash;&gt;-->
<!--&lt;!&ndash;                                                                    :from="numberFrom"&ndash;&gt;-->
<!--&lt;!&ndash;                                                                    :format="theFormat"&ndash;&gt;-->
<!--&lt;!&ndash;                                                                    animationPaused&ndash;&gt;-->
<!--&lt;!&ndash;                                                                    :to="numberTo"&ndash;&gt;-->
<!--&lt;!&ndash;                                                                    :duration="duration"&ndash;&gt;-->
<!--&lt;!&ndash;                                                                    easing="Power4.easeOut"&ndash;&gt;-->
<!--&lt;!&ndash;                                                                    /> &ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                                                        </td>&ndash;&gt;-->
<!--&lt;!&ndash;                                                    </tr>&ndash;&gt;-->
<!--&lt;!&ndash;                                                   &ndash;&gt;-->
<!--&lt;!&ndash;                                                    </tbody>&ndash;&gt;-->
<!--                                                    &lt;!&ndash; </transition> &ndash;&gt;-->
<!--   </table>-->
    <!--    old total ui with functionality start-->
                                                <!-- </div> -->

<!-- <CCard>
    <CCardBody>
       
        <CRow @click="isTotalFare = !isTotalFare">
           
              <CCol>
                  {{$t('totalpriceInfo.total')}}
              </CCol>
              <CCol>
                  {{totalPriceObj.Currency}}
              </CCol>
              <CCol>
                  {{totalPriceObj.TotalAmount}}
              </CCol>
         
        </CRow>
       <CCollapse :show="isTotalFare" class="mt-2">
            <CCard body-wrapper>
              <CCol>
                {{$t('totalpriceInfo.tax')}} {{totalPriceObj.TotalTax}}
              </CCol>
              <CCol>
                {{$t('totalpriceInfo.baseFare')}} {{totalPriceObj.TotalBaseFare}}
              </CCol>
              
            </CCard>
          </CCollapse>
         
    </CCardBody>
</CCard> -->
<!-- </div></div> -->


</template>
<script>

import { TRIP, PAX, PAX_COUNT } from "../../util/constants.js";
import Logger from "../../services/logger";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import router ,{navigate,goBack }from "../../router/index";

import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import { COMPONENT_NAME, PATHNAME } from "../../util/constants";
import BaseConfiguration from "../../config/base.js";
import SERVICE_URL from "../../config/API_DATA";
import { mapGetters, mapActions } from "vuex";
import Vue from 'vue';
import VueNumber from 'vue-number-animation';
Vue.use(VueNumber);
export default {
  name: COMPONENT_NAME.C_TOTALPRICE,
  components: {
    
  },
   props: {
     selflightObj:{
         type:Object,
            default: null
       },
        isFooter:{
         type:Boolean,
            default: null
       },
       
   },
  data: () => ({
    // scaleClass:false,
     isTotalFare: false,
     totalPriceObj:null,
  }),
   watch: {    
      selflightObj:{
        immediate: false, 
        deep: true,
    handler: function (newVal, oldVal) {
      
      if(oldVal==newVal||oldVal!=newVal){
       
        this.totalPriceObj = this.getFormattedTotal(this.sSearchObj,this.selflightObj);
    }
        
      }
      }
      
      },
      created(){
    this.totalPriceObj = this.getFormattedTotal(this.sSearchObj,this.selflightObj);
  },
  methods:{
    theFormat(number) {
      return this.$options.filters.amountformat(number);
    },
    // completed() {
    //   console.log("Animation ends!");
    //   this.scaleClass = true;
    // },


     playAnimation() {
       this.isTotalFare=!this.isTotalFare;
            //  this.scaleClass = false;

            // this.$refs.totalPaxNum.play();
        },
    //to get total fare for one way , round trip

    getFormattedTotal(pSearchObj, pFlightInfodata) {
      let retValue = {
        AdultPrice: null,
        ChildPrice: null,
        InfantPrice: null,
        TotalTax: 0,
        TotalBaseFare: 0,
        TotalAmount: 0,
        Currency: 0,
       
      };

      try {
     if (pFlightInfodata.ib && pFlightInfodata.ib.clientPricing && pFlightInfodata.ob && pFlightInfodata.ob.clientPricing) {
          
          if(pFlightInfodata.ob.clientPricing.hasOwnProperty('isTotal')&&pFlightInfodata.ob.clientPricing.isTotal){
               retValue.PaymentAmount=pFlightInfodata.ob.clientPricing.isTotal;
             


           }
          
          if (pSearchObj.pax.adultCount > 0) {
            retValue.AdultPrice = this.paxPricing(
              pFlightInfodata,
              "AdultPrice"
            );
          }

          if (pSearchObj.pax.childCount > 0) {
            retValue.ChildPrice = this.paxPricing(
              pFlightInfodata,
              "ChildPrice"
            );
          }

          if (pSearchObj.pax.infantCount > 0) {
            retValue.InfantPrice = this.paxPricing(
              pFlightInfodata,
              "InfantPrice"
            );
          }
          
          retValue.TotalTax = this.getFinalTotal(pFlightInfodata).TotalTax;
          retValue.TotalBaseFare = this.getFinalTotal(
            pFlightInfodata
          ).TotalBaseFare;
          retValue.TotalAmount = this.getFinalTotal(
            pFlightInfodata
          ).TotalAmount;

          retValue.Currency = this.getFinalTotal(pFlightInfodata).Currency;
          // retValue.total= this.getFinalTotal(pFlightInfodata);
          // alert(JSON.stringify(total));
        }
        else if (pFlightInfodata.ob != null) {
          retValue = pFlightInfodata.ob.clientPricing;
        } else if (pFlightInfodata.ib != null) {
          retValue = pFlightInfodata.ib.clientPricing;
        } 
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.FLIGHTRESULTS,
          "error in getFormattedTotal",
          err.toString(),
          "getFormattedTotal",
          LOG_TYPE.ERROR
        );
      }

      return retValue;
    },

    // total calculation of both ob and ib

    getFinalTotal(pFlightInfodata) {
      let retValue = {
        TotalTax: 0,
        TotalBaseFare: 0,
        TotalAmount: 0,
        Currency: 0
      };
      try {
        retValue.TotalTax =
          pFlightInfodata.ob.clientPricing.TotalTax +
          pFlightInfodata.ib.clientPricing.TotalTax;
        retValue.TotalBaseFare =
          pFlightInfodata.ob.clientPricing.TotalBaseFare +
          pFlightInfodata.ib.clientPricing.TotalBaseFare;
        retValue.TotalAmount =
          pFlightInfodata.ob.clientPricing.TotalAmount +
          pFlightInfodata.ib.clientPricing.TotalAmount;
        retValue.Currency = pFlightInfodata.ob.clientPricing.Currency;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.FLIGHTRESULTS,
          "error in getFinalTotal",
          err.toString(),
          "getFinalTotal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    //total tax calculation for all types of pax

    paxPricing(pFlightInfodata, pPaxPrice) {
      let retValue = {
        Tax: null,
        BaseFare: null,
        Total: null
      };
      try {
        if (pPaxPrice) {
          // console.log(JSON.stringify(Object.keys(pFlightInfodata.ob.clientPricing).length));
          for (let i = 0;i < Object.keys(pFlightInfodata.ob.clientPricing).length;i++) {
            
            if (Object.keys(pFlightInfodata.ob.clientPricing)[i] == pPaxPrice) {
              for (let j = 0;j < Object.keys(pFlightInfodata.ib.clientPricing).length;j++) {
                if ( Object.keys(pFlightInfodata.ib.clientPricing)[j] == pPaxPrice) {
                  retValue.Tax =Math.round((Object.values(pFlightInfodata.ob.clientPricing)[i].Tax +
                        Object.values(pFlightInfodata.ib.clientPricing)[j].Tax) * 1e12) / 1e12;
                  retValue.BaseFare =((Object.values(pFlightInfodata.ob.clientPricing)[i].BaseFare +
                      Object.values(pFlightInfodata.ib.clientPricing)[j].BaseFare) *1e12) / 1e12;
                  retValue.Total =Math.round((Object.values(pFlightInfodata.ob.clientPricing)[i].Total +
                        Object.values(pFlightInfodata.ib.clientPricing)[j].Total) *1e12) / 1e12;
                  break; // j=0;
                }
              }
            }
          }
          
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.FLIGHTRESULTS,
          "error in paxPricing",
          err.toString(),
          "paxPricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

  },
   computed: {
    ...mapGetters("sCSearch", {
          sSearchObj: "GET_SEARCH_OBJ",      
        }),
    
  },
}
</script>
<style>
/*.scaleBig {*/
/*  font-size: 18px;*/
/*}*/
</style>